import React, { PropTypes } from 'react';
import classNames from 'classnames';

import { boldButton, italicButton, underlineButton, linkButton, alignLeft, alignCenter, alignRight, justify, quote, bulletList } from './ButtonSvgs'

const SingleButton = (props) => {
    const button = ()=> {
        switch ( props.style ) {
            case 'BOLD':
                return boldButton;
            case 'ITALIC':
                return italicButton;
            case 'UNDERLINE':
                return underlineButton;
            case "LINK":
                return linkButton;
            case "ALIGN_LEFT":
                return alignLeft;
            case "ALIGN_CENTER":
                return alignCenter;
            case "ALIGN_RIGHT":
                return alignRight;
            case "JUSTIFY":
                return justify;
            case "QUOTE":
                return quote;
            case "BULLET_LIST":
                return bulletList;
            default:
                return props.label
        }
    };


    const onToggle = (e) =>{
        e.preventDefault();
        if(!props.disabled) {
            props.onToggle(props.style);
        }
    };

    const className = classNames({
       "richutils__button" : true,
        "-active" : props.active,
        "-inactive" :props.disabled

    });

    return (
    <div className={className} onMouseDown={onToggle}>
        <div className="richutils__svg-wrapper">
            {button()}
        </div>
        <div className="rich-button__label">
            {props.label}
            <div className="rich-button__arrow"></div>
        </div>
    </div>
    )
};

SingleButton.propTypes = {
    label: PropTypes.string,
    style: PropTypes.string,
    disabled: PropTypes.bool
};

export default SingleButton;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/SingleButton.js